export class UPIApp {
    constructor(id, displayName, base64Icon) {
        this.id = id;
        this.displayName = displayName;
        this.base64Icon = base64Icon;
    }
}
//# sourceMappingURL=definitions.js.map